import { render } from "./MainRanking.vue?vue&type=template&id=4a3c77ba&scoped=true"
import script from "./MainRanking.vue?vue&type=script&lang=js"
export * from "./MainRanking.vue?vue&type=script&lang=js"

import "./MainRanking.vue?vue&type=style&index=0&id=4a3c77ba&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3c77ba"]])

export default __exports__